import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { ThemeService } from './theme.service';
import { NB_THEME_CONFIG, ThemeConfig } from './theme.types';

/**
 * Configure the design-system theme and eagerly start the {@link ThemeService}
 * so the root attributes are applied before first paint.
 *
 * @example
 * providers: [provideTheme({ scheme: 'system' })]
 */
export function provideTheme(config: Partial<ThemeConfig> = {}): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: NB_THEME_CONFIG, useValue: config },
    provideEnvironmentInitializer(() => inject(ThemeService)),
  ]);
}
